module.exports = __webpack_public_path__ + "img/runway.66527d46.svg";